// extracted by mini-css-extract-plugin
module.exports = {"inputFilter":"SalesMonitorTableStyle_inputFilter__1_yWd"};